<template>
  <div>
    <div class="main-page">
      <h1 class="page-title">
        申請書選択
      </h1>
      <div class="page-content">
        <ul class="list-instructions">
          <li>
            <p class="text-jp">
              申請内容を選択し「次へ」を押してください（複数可）
            </p>
          </li>
        </ul>
        <section class="section-category">
          <h2 class="title-item green">
            <span class="jp">
              申請内容
              <span class="small">（必須項目）</span>
            </span>
          </h2>
          <div class="content">
            <p class="desc">
              以下より選択してください（複数選択可）
            </p>
            <div class="list-checkbox">
              <div class="item">
                <label class="item-checkbox">
                  <input
                    v-model="forms"
                    type="checkbox"
                    :value="2"
                    @change="checkForm"
                  >
                  <span class="text-label border-dark">
                    <span class="jp">住民異動届（市外への異動 or 市内での異動）</span>
                  </span>
                </label>
              </div>
              <div class="item">
                <label class="item-checkbox">
                  <input
                    v-model="forms"
                    type="checkbox"
                    :value="3"
                    @change="checkForm"
                  >
                  <span class="text-label border-dark">
                    <span class="jp">住民票写し発行</span>
                  </span>
                </label>
              </div>
              <div class="item">
                <label class="item-checkbox">
                  <input
                    v-model="forms"
                    type="checkbox"
                    :value="4"
                    @change="checkForm"
                  >
                  <span class="text-label border-dark">
                    <span class="jp">印鑑登録証明書発行</span>
                  </span>
                </label>
              </div>
              <div class="item">
                <label class="item-checkbox">
                  <input
                    v-model="forms"
                    type="checkbox"
                    :value="5"
                    @change="checkForm"
                  >
                  <span class="text-label border-dark">
                    <span class="jp">マイナンバーカードの電子証明書の発行・更新</span>
                  </span>
                </label>
              </div>
            </div>
            <p
              v-if="errorShown"
              class="alert-text"
            >
              <span class="jp">エラー：選択してください</span>
            </p>
          </div>
        </section>
        <div class="block-text-final-desc">
          <p>※上記以外は窓口の申請書にてお手続きをお願いします</p>
        </div>
        <button
          type="button"
          class="button trans"
          @click="next()"
        >
          <span class="txt">次へ</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Selection',
  data() {
    return {
      forms: [],
      errorShown: false,
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    this.forms = this.$store.state.selection;
  },
  methods: {
    /**
     * validating form input
     */
    checkForm: function() {
      let dataForms = this.forms;
      if(dataForms.indexOf(1) == -1) {
        dataForms.unshift(1);
      }
      if (dataForms.length > 1) {
        this.errorShown = false;
      } else {
        this.errorShown = true;
      }
      return dataForms;
    },
    /**
     * Go to next page if there is at least a checkbox is checked
     */
    next: function () {
      let dataForms = this.checkForm();

      if (dataForms.length > 1) {
        this.$store.state.selection = dataForms.sort();
        this.$router.push({ name: 'agreements' });
      }
    },
  },
};
</script>